import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Popover, Button } from "antd";
import logoPng from "../../assets/img/logo2.png";
import { usePermisos, usePuedeSolicitarCambios } from "../../context/PermisosContext";
import "../../assets/css/fontawesome-free-6.1.0-web/css/all.min.css";

const SIDEBAR_COLLAPSED = 56;
const SIDEBAR_EXPANDED = 228;

const ALL_ITEMS = [
  { label: "Inicio", icon: "fa-solid fa-house", path: "/home", match: (p) => p.startsWith("/home") },
  {
    label: "Centro Conciliación",
    icon: "fa-solid fa-handshake",
    path: "/materias/laboral/centro-conciliacion",
    match: (p) => p.startsWith("/materias/laboral/centro-conciliacion"),
    modulo: "conciliacion",
  },
  {
    label: "Tribunal",
    icon: "fa-solid fa-gavel",
    path: "/materias/laboral/tribunal",
    match: (p) => p.startsWith("/materias/laboral/tribunal"),
    modulo: "tribunal",
  },
  {
    label: "Junta de Conciliación",
    icon: "fa-solid fa-clipboard-check",
    path: "/materias/laboral/junta-conciliacion",
    match: (p) => p.startsWith("/materias/laboral/junta-conciliacion"),
    modulo: "junta",
  },
  {
    label: "Desvinculaciones",
    icon: "fa-solid fa-user-minus",
    path: "/materias/laboral/desvinculaciones",
    match: (p) => p.startsWith("/materias/laboral/desvinculaciones"),
    modulo: "desvinculaciones",
  },
  { label: "Abogados", icon: "fa-solid fa-people-group", path: "/abogados", match: (p) => p.startsWith("/abogados"), modulo: "abogados" },
  { label: "Agenda", icon: "fa-solid fa-calendar", path: "/agenda", match: (p) => p.startsWith("/agenda"), modulo: "agenda" },
  { label: "Informes", icon: "fa-solid fa-chart-simple", path: "/informes", match: (p) => p.startsWith("/informes"), modulo: "informes" },
  { label: "Autoridades", icon: "fa-solid fa-landmark", path: "/autoridades", match: (p) => p.startsWith("/autoridades"), modulo: "autoridades" },
  { label: "Configuración", icon: "fa-solid fa-gears", path: "/configuracion", match: (p) => p.startsWith("/configuracion"), modulo: "configuracion" },
  { label: "Corresponsales", icon: "fa-solid fa-address-book", path: "/corresponsales", match: (p) => p.startsWith("/corresponsales"), modulo: "corresponsales" },
  { label: "Empresas", icon: "fa-solid fa-city", path: "/empresas", match: (p) => p.startsWith("/empresas"), modulo: "empresas" },
  { label: "Usuarios", icon: "fa-solid fa-users", path: "/usuarios", match: (p) => p.startsWith("/usuarios"), modulo: "usuarios" },
  { label: "Programador", icon: "fa-solid fa-code", path: "/programador", match: (p) => p.startsWith("/programador"), modulo: "programador" },
  { label: "Mis solicitudes", icon: "fa-solid fa-list-check", path: "/mis-solicitudes", match: (p) => p.startsWith("/mis-solicitudes"), special: "solicitarCambios" },
];

export default function VerticalSidebar() {
  const navigate = useNavigate();
  const location = useLocation();
  const pathname = location.pathname || "/";
  const [hovered, setHovered] = useState(false);
  const [userOpen, setUserOpen] = useState(false);
  const { perm } = usePermisos() || { perm: () => true };
  const puedeSolicitarCambios = usePuedeSolicitarCambios();

  const userEmail = localStorage.getItem("email") || "—";
  const userInitials = (() => {
    const name = (localStorage.getItem("email") || "JD").trim();
    const a = name[0] || "J";
    const b = name[1] || "D";
    return (a + b).toUpperCase();
  })();

  const width = hovered ? SIDEBAR_EXPANDED : SIDEBAR_COLLAPSED;

  const items = ALL_ITEMS.filter((item) => {
    if (item.special === "solicitarCambios") return puedeSolicitarCambios;
    return !item.modulo || perm(item.modulo, "modulo");
  });

  const userCard = (
    <div className="eh-user-pop">
      <div className="eh-user-avatar">{userInitials}</div>
      <div className="eh-user-email">
        <small className="text-secondary">{userEmail}</small>
      </div>
      <div className="eh-user-actions">
        <Button
          danger
          size="small"
          className="w-100 mt-2"
          onClick={() => {
            localStorage.removeItem("token");
            setUserOpen(false);
            navigate("/login");
          }}
        >
          Log out
        </Button>
      </div>
    </div>
  );

  return (
    <aside
      className="vs-root"
      style={{ width }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {/* Logo */}
      <div className="vs-logo">
        <img src={logoPng} alt="Logo" className="vs-logo-img" />
        {hovered && <span className="vs-logo-text">Ontiveros</span>}
      </div>

      {/* Items unificados */}
      <nav className="vs-nav vs-nav--all">
        {items.map((item) => {
          const active = item.match(pathname);
          return (
            <button
              key={item.path}
              type="button"
              disabled={item.disabled}
              className={`vs-item${active ? " vs-item--active" : ""}${item.disabled ? " vs-item--disabled" : ""}`}
              onClick={() => !item.disabled && navigate(item.path)}
              title={!hovered ? item.label : undefined}
            >
              <span className="vs-item-icon">
                <i className={item.icon} />
              </span>
              {hovered && <span className="vs-item-label">{item.label}</span>}
            </button>
          );
        })}
      </nav>

      {/* Usuario fijo abajo */}
      <div className="vs-bottom">
        <Popover
          open={userOpen}
          onOpenChange={setUserOpen}
          trigger="click"
          placement="rightBottom"
          overlayClassName="eh-popover"
          content={userCard}
        >
          <button
            type="button"
            className="vs-avatar-btn"
            title={!hovered ? userEmail : undefined}
          >
            <span className="vs-avatar">{userInitials}</span>
            {hovered && <span className="vs-avatar-email">{userEmail}</span>}
          </button>
        </Popover>
      </div>
    </aside>
  );
}
